import { useEffect } from "react";
import { breadCrumbsVar } from "graphql/cache";

const useBreadCrumbs = (breadcrumbs = []) => {

    /*eslint-disable */
    useEffect(() => {
        if (!breadcrumbs || !Array.isArray(breadcrumbs))
        {
            console.error('Breadcrumbs is not an array:', breadcrumbs);
            return;
        }
        breadCrumbsVar(Array.isArray(breadcrumbs) ? breadcrumbs : []);
        return () => breadCrumbsVar([]);
    }, [ JSON.stringify(breadcrumbs) ]);
    /*eslint-enable */
};

export default useBreadCrumbs;